import React, { useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Menu,
    MenuItem
} from '@mui/material';
import SortIcon from '../../assets/images/Dashboard/chevron-down.svg';
import ascToDesc from '../../assets/images/CustomerManagement/ascToDesc.svg';
import descToAsc from '../../assets/images/CustomerManagement/descToAsc.svg';
import SbActionDropdownButton from '../Buttons/SbActionDropdownButton';
import StatusBadgeWithDropdown from '../Buttons/StatusBadgeWithDropdown';

const columns = [
    { id: 'orderNumber', label: 'Order Number', align: 'left', minWidth: '150px' },
    { id: 'config', label: 'CONFIG', align: 'left', minWidth: '250px' },
    { id: 'operator', label: 'Operator', align: 'left', minWidth: '120px' },
    { id: 'rig', label: 'Rig', align: 'left', minWidth: '100px' },
    { id: 'padName', label: 'Pad Name', align: 'left', minWidth: '120px' },
    { id: 'power', label: 'Power', align: 'left', minWidth: '100px' },
    { id: 'minTemp', label: 'Min Temp', align: 'left', minWidth: '120px' },
    { id: 'maxTemp', label: 'Max Temp', align: 'left', minWidth: '120px' },
    { id: 'quantity', label: 'Quantity', align: 'left', minWidth: '80px' },
    { id: 'date', label: 'Date', align: 'left', minWidth: '120px' },
    { id: 'comments', label: 'Comments', align: 'left', minWidth: '150px' },
    { id: 'dynoReq', label: 'Dyno Req', align: 'left', minWidth: '120px' },
    { id: 'inspectionReq', label: 'Inspection Req', align: 'left', minWidth: '150px' },
];

const ManageOrdersTable = ({ orders }) => {
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('orderNumber');
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentSortColumn, setCurrentSortColumn] = useState(null);

    const handleRequestSort = (event, property) => {
        setCurrentSortColumn(property);
        setAnchorEl(event.currentTarget);
    };

    const handleSortOrderChange = (newOrder) => {
        setOrder(newOrder);
        setOrderBy(currentSortColumn);
        setAnchorEl(null);
    };

    const sortedOrders = React.useMemo(() => {
        const stabilizedData = orders.map((el, index) => [el, index]);
        stabilizedData.sort((a, b) => {
            const orderModifier = order === 'asc' ? 1 : -1;
            if (a[0][orderBy] < b[0][orderBy]) return -1 * orderModifier;
            if (a[0][orderBy] > b[0][orderBy]) return 1 * orderModifier;
            return a[1] - b[1];
        });
        return stabilizedData.map((el) => el[0]);
    }, [orders, order, orderBy]);

    return (
        <TableContainer component={Paper} sx={{ maxHeight: 440 }} className="table-container">
            <Table>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                <div style={{ display: 'flex', alignItems: 'center' }} className="table-header-div">
                                    {column.label}
                                    <IconButton size="small" onClick={(event) => handleRequestSort(event, column.id)}>
                                        <img src={SortIcon} alt="Sort" />
                                    </IconButton>
                                </div>
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedOrders.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={columns.length} align="center">
                                No orders available
                            </TableCell>
                        </TableRow>
                    ) : (
                        sortedOrders.map((order, index) => (
                            <TableRow key={index}>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align={column.align}>
                                        {column.id === 'dynoReq' || column.id === 'inspectionReq'
                                            ? order[column.id] ? 'Yes' : 'No'
                                            : order[column.id]}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                <MenuItem onClick={() => handleSortOrderChange('asc')}>
                    <img src={ascToDesc} alt="" />&nbsp;&nbsp;
                    Ascending to Descending
                </MenuItem>
                <MenuItem onClick={() => handleSortOrderChange('desc')}>
                    <img src={descToAsc} alt="" />&nbsp;&nbsp;
                    Descending to Ascending
                </MenuItem>
            </Menu>
        </TableContainer>
    );
};

export default ManageOrdersTable;
